<template>
    <div class="row">
       <div class="mx-auto col-md-12">                        
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <b-card                  
                        class="mb-2"
                        header="Habilitar/Desabilitar Modo Manutenção"
                        header-tag="header">
                        <div class="row mb-2">
                          <div class="col-6 col-md-3 font-weight-bold">
                            Modo manutenção:
                            <span id="modomanutencao_help">
                              <font-awesome-icon
                                :icon="['fas', 'question-circle']"
                                class="text-info"
                              />
                            </span>
                          </div>
                          <b-tooltip
                            target="modomanutencao_help"
                            triggers="hover"
                            placement="right"
                            variant="info"
                          >
                            Se HABILITADO, tira o sistema do ar para todos usuários (exceto
                            o SUPERADMINISTRADOR e ADMINISTRADOR).
                          </b-tooltip>

                          <div class="col">
                            <b-form-checkbox
                              v-model="modoManutencao"
                              name="check-button"
                              switch
                            >
                              <b>{{ modoManutencao ? "HABILITADO" : "DESABILITADO" }}</b>
                            </b-form-checkbox>
                          </div>
                        </div>                                                                 
                    </b-card>
                    <div class="text-center mt-3">
                        <b-row>
                            <b-col class="text-right"> 
                                <b-button variant="success" @click="editar">
                                    <font-awesome-icon                                                                      
                                        :icon="['fas','save']"
                                        title="Salvar"
                                        class="mr-1"
                                    />
                                    Salvar
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>           
                </div>                
            </div>
       </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      modoManutencao: false,
    };
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },
  },
  methods: {

    editar(){
      let id = 0;
      let modoManutencao = this.modoManutencao ? "1" : "2";
      this.$api.put(`parametros/manutencao/${id}`, {flag_manutencao: modoManutencao})
        .then(response => {                    
            if(response.status === 200 ){         
              this.modoManutencao = response.data.dados.flag_manutencao === "1"; 
              this.$helpers.showToast(this, 'Sucesso', response.data.message,'success');                                      
            } 
        })
        .catch(error => {                               
            if(error.response.data){                        
                this.$helpers.showToast(this, 'Erro', error.response.data.message,' danger');                        
            } 
        });  
    },
 
    obter(){                
      return this.$api.get(`manutencao`)
        .then(response => {  
            if(response.status == 200){                                                
              this.modoManutencao = response.data.dados.flag_manutencao === "1";                                                  
            }                                                            
        })
        .catch(error => {   
            if(error.response.data){                        
                this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');                        
            }                                                                          
        });                                                 
    },
  },
  mounted() {
    this.obter();
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
  text-align: right;
}
</style>
